export default "__VITE_ASSET__CMX$V7P___"